import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Close_black from "../../assets/close_black.svg";
import Close_white from "../../assets/white-close.svg";
import { onGetProfileDetails, onJustReducerUpdate } from '../../redux/action';
import { IS_NEW_COMER, PROFILE_DETAILS, REGISTER_DETAILS } from '../../redux/action_type';
import moment from "moment";
import { addOldAccount, onCheckAccounts, onCheckLinkedAccount, onCheckUserProfile, onMapAccounts } from '../../services';
import _ from 'lodash';
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC';
import { v4 as uuid } from 'uuid'
import { useToast } from '../../toast';

function AccountLogin(props) {
    const { setLoading, setContent } = props;
    const history = useHistory();
    const dispatch = useDispatch()
    const [timer, setTimer] = useState(300)
    const [modalCount, setModalCount] = useState(0)
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    const intervalRef = useRef(null)
    const myInterval = useRef(null)
    const profileDetails = useSelector((state) => state.profileDetails)
    const profileDetailsLoading = useSelector((state) => state.profileDetailsLoading)
    const toast = useToast();

    useEffect(() => {
        setLoading(profileDetailsLoading)
    }, [profileDetailsLoading])

    useEffect(() => {
        if (!_.isEmpty(profileDetails?.cp_creators)) {
            const { is_linked } = profileDetails?.cp_creators?.[0]
            if (is_linked) {
                clearTimer()
                return
            }
        }
        intervalRef.current = setInterval(() => {
            if (timer === 0) {
                if (modalCount === 3) {
                    clearInterval(intervalRef.current)
                    $("#link-account-popup-3").modal("show")
                    return
                }
                $("#link-account-popup-2").modal("show")
            } else {
                setTimer(timer - 1)
            }
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, [timer])

    const onRemoveLinkAccount = () => {
        setLoading(true)
        const { publisher_id, } = profileDetails?.cp_creators?.[0]
        addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
            setLoading(false)
            if (responseData.status) {
                dispatch(onGetProfileDetails(authData.josh_user_id))
                history.push("/dashboards")
            }
        }).catch(err => console.log("err3", err))
    }

    const clearTimer = () => {
        clearInterval(intervalRef.current)
        intervalRef.current = null
    }

    useEffect(() => {
        if (authData && Object.keys(authData)?.length != 0) {
            dispatch(onGetProfileDetails(authData.josh_user_id))
        }
        $(document).ready(function () {

            $('ciq-cookie-banner').css('display', 'none');
        });
    }, [])

    useEffect(() => {
        if (profileDetails) {
            if (!_.isEmpty(profileDetails?.cp_creators)) {
                const { is_linked } = profileDetails?.cp_creators?.[0]
                if (is_linked) {
                    return
                }
            }
            myInterval.current = setInterval(() => {
                if (!_.isEmpty(profileDetails?.cp_creators)) {
                    const { login_network, publisher_id, is_linked } = profileDetails?.cp_creators?.[0]
                    let dateEnd = moment(profileDetails?.cp_creators?.[0]?.createdAt);
                    let dateNow = moment.utc(new Date());
                    let minutesDiff = dateNow.diff(dateEnd, "minutes");
                    console.log("123", login_network, publisher_id, minutesDiff, is_linked)
                    const payload = {
                        "network": login_network,
                        "publisher_id": publisher_id
                    }
                    if (is_linked) {
                        return
                    }
                    // if (minutesDiff > 14 && !is_linked) {
                    //     setLoading(true)
                    //     addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
                    //         setLoading(false)
                    //         if (responseData.status) {
                    //             dispatch(onGetProfileDetails(authData.josh_user_id))
                    //             history.push("/dashboards")
                    //         }
                    //     }).catch(err => console.log("err3", err))
                    // }
                    onCheckAccounts(payload).then((res) => {
                        console.log("123res", res)
                        if (res.data.linked) {
                            onCreatorLinkCheck()
                            clearInterval(myInterval.current)
                        }
                    })
                }
            }, 15000);
        }
        return () => clearInterval(myInterval.current)
    }, [profileDetails])

    const clearInter = () => {
        clearInterval(myInterval.current)
        myInterval.current = null
        clearTimer()
    }
    const onResetTimer = () => {
        setTimer(300)
        setModalCount(modalCount + 1)
    }
    const onCreatorLinkCheck = () => {
        if (profileDetails?.cp_creators?.length > 0) {
            clearTimer()
            const { login_network, login_network_username, publisher_id, username, is_linked } = profileDetails?.cp_creators?.[0]
            const creatorPayload = {
                "publisher_name": username,
                "network": login_network,
                "userid": login_network_username,
                "publisher_id": publisher_id
            }
            setLoading(true)
            onCheckLinkedAccount(creatorPayload).then((res) => {
                console.log("123", res)
                if (res.status) {
                    const { linked, linked_with_other, linked_same } = res.data
                    const mapPayload = {
                        "publisher_name": username,
                        "network": login_network,
                        "userid": login_network_username,
                        publisher_id
                    }
                    if (linked && linked_with_other) {
                        console.log("123/add-old-account", { publisher_id })
                        setLoading(true)
                        setContent("Your primary account is linked successfully. Fetching your other social accounts.")
                        dispatch(onJustReducerUpdate(true, IS_NEW_COMER))
                        addOldAccount({ publisher_id }).then(responseData => {
                            console.log("123responseData1", responseData)
                            if (responseData.status) {
                                onMapAccounts(mapPayload).then(responseMapData => {
                                    console.log("123responseMapData1", responseMapData)
                                    if (responseMapData.status) {
                                        setLoading(false)
                                        setContent("")
                                        dispatch(onGetProfileDetails(authData.josh_user_id))
                                        if (responseMapData.is_found_account) {
                                            onGoBack()
                                        } else {
                                            toast.open("Access your social performance and campaign invites", "", true, () => history.push("/dashboards"))
                                        }
                                    }
                                }).catch(err => {
                                    setContent("")
                                    setLoading(false)
                                })
                            }
                        }).catch(err => console.log("err2", err))
                    } else if (linked && linked_same) {
                        console.log("123/map-accounts", mapPayload)
                        setLoading(true)
                        setContent("Your primary account is linked successfully.  Fetching your other social accounts.")
                        dispatch(onJustReducerUpdate(true, IS_NEW_COMER))
                        onMapAccounts(mapPayload).then(responseData => {
                            console.log("123responseData3", responseData)
                            if (responseData.status) {
                                setLoading(false)
                                setContent("")
                                dispatch(onGetProfileDetails(authData.josh_user_id))
                                if (responseData.is_found_account) {
                                    onGoBack()
                                } else {
                                    toast.open("Access your social performance and campaign invites", "", true, () => history.push("/dashboards"))
                                }
                            }
                        }).catch(err => {
                            setContent("")
                            setLoading(false)
                        })
                    }
                } else {
                    setLoading(false)
                }
            }).catch(err => setLoading(false))
        }
    }

    const onGoBack = () => {
        console.log("onBack")
        $("#link-account-popup-4").modal("show")
        // history.push("/dashboards")
    }
    const onClose = () => {
        clearInterval(myInterval.current)
        if (!_.isEmpty(profileDetails?.cp_creators)) {
            const { login_network, publisher_id, is_linked } = profileDetails?.cp_creators?.[0]
            const payload = {
                "network": login_network,
                "publisher_id": publisher_id
            }
            if (is_linked) {
                dispatch(onGetProfileDetails(authData.josh_user_id))
                history.goBack();
                return
            }
            setLoading(true)
            onCheckAccounts(payload).then((res) => {
                if (!res.data.linked && !res.data.this_linked) {
                    addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
                        setLoading(false)
                        if (responseData.status) {
                            dispatch(onGetProfileDetails(authData.josh_user_id))
                            history.push("/dashboards")
                        }
                    }).catch(err => console.log("err3", err))
                    return
                }
                if (res.data.this_linked) {
                    setLoading(false)
                    history.push("/dashboards")
                    return
                }
                if (res.data.linked && !res.data.this_linked) {
                    onCreatorLinkCheck()
                }
            })
        } else {
            history.push("/dashboards")
        }
    }

    return (
        <>
            <div className='wrapper'>
                {/* Session Popup Start Here */}
                <div
                    className="modal fade logout-popup-wrap session-popup"
                    id="link-account-popup-2"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                        <div className="modal-content   ">
                            <div className="modal-body pt-0 mt-3">
                                <div className='logout-card'>
                                    <h2> Link Account</h2>
                                    <p>Link your account before session expires.</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className='common-btn'>
                                    <button className='bg-btn' onClick={onResetTimer} data-dismiss="modal">Link</button>
                                    {/* <button data-dismiss="modal" className='d-none'>Cancel</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Session Popup End Here */}
                {/* Session Expired  Popup Start Here */}
                <div
                    className="modal fade logout-popup-wrap session-popup"
                    id="link-account-popup-3"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <button type="button" className="close" data-dismiss="modal">
                                    <span aria-hidden="true">
                                        <img src={Close_black} alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body pt-0 mt-3">
                                <div className='logout-card'>
                                    <h2>Session Expired</h2>
                                    <p>Link your account again</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className='common-btn'>
                                    <button className='bg-btn' type='button' onClick={onRemoveLinkAccount} data-dismiss="modal">Link</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Session Expired Popup End Here */}
                {/* Social Link Account Popup Start Here */}
                <div
                    className="modal fade logout-popup-wrap session-popup social-link-account"
                    id="link-account-popup-4"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                        <div className="modal-content   ">
                            <div className="modal-header border-0">
                                <button type="button" className="close" data-dismiss="modal">
                                    <span aria-hidden="true">
                                        <img src={Close_black} alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body pt-0 mt-3">
                                <div className='logout-card'>
                                    <h2>Link Social Accounts</h2>
                                    <p>We have found your other social accounts and added them to your profile</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className='common-btn'>
                                    <button className='bg-btn' onClick={() => toast.open("Access your social performance and campaign invites", "", true, () => history.push("/dashboards"))} data-dismiss="modal">Okay</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Social Link Account Popup Start Here */}
                <div className='middle-content-wrap iframe-Container'>
                    <div className='bordr-bottom-div'></div>
                    <button type="button" className="close mb-2">
                        <span aria-hidden="true">
                            <img src={Close_white} className="closeButton" alt="" onClick={onClose} />
                        </span>
                    </button>
                    <iframe name={uuid()} id="account-auth" className='link-account' src={profileDetails?.cp_creators?.[0]?.account_link || ""} frameborder="0"></iframe>
                </div>
            </div>
        </>
    )
}

export default IsLoadingHOC(AccountLogin)